import { getReservasExperidas } from "../services/serviceViaje"
import { newCompraItem, updateAutorizacionCompraItem } from "../services/comprasService"
const dataInicial = {
    reservas: [],
    total: 0,
    busquedaReferencia: "NA",
    busquedaEstatus: "NA",
    pagina: 0,
    registroPagina: 10,
    exito: 0,
};

const GET_RESERVAS_EXPIRADAS_ALL = "GET_RESERVAS_EXPIRADAS_ALL"
const GET_RESERVAS_EXPIRADAS_BUSQUEDA_ALL = "GET_RESERVAS_EXPIRADAS_BUSQUEDA_ALL"
const GET_RESERVAS_EXPIRADAS_REGISTROS_PAGINA = "GET_RESERVAS_EXPIRADAS_REGISTROS_PAGINA"
const GET_RESERVAS_EXPIRADAS_PAGINA = "GET_RESERVAS_EXPIRADAS_PAGINA"
const POST_RESERVAS_EXPIRADAS_EXITO = "POST_RESERVAS_EXPIRADAS_EXITO"
const PUT_RESERVAS_EXPIRADAS_AUTORIZADO_EXITO = "PUT_RESERVAS_EXPIRADAS_AUTORIZADO_EXITO"
const CLEAR_RESERVAS_EXPIRADAS_STATE = "CLEAR_RESERVAS_EXPIRADAS_STATE"
export default function reservasExpiradasReducer(state = dataInicial, action) {
    switch (action.type) {
        case GET_RESERVAS_EXPIRADAS_PAGINA:
            return {
                ...state,
                reservas: action.payload.reservas,
                total: action.payload.total,
                pagina: action.payload.pagina,
            }
        case GET_RESERVAS_EXPIRADAS_REGISTROS_PAGINA:
            return {
                ...state,
                reservas: action.payload.reservas,
                total: action.payload.total,
                registroPagina: action.payload.registroPagina
            }
        case GET_RESERVAS_EXPIRADAS_BUSQUEDA_ALL:
            return {
                ...state,
                reservas: action.payload.reservas,
                total: action.payload.total,
                busquedaReferencia: action.payload.busquedaReferencia,
                busquedaEstatus: action.payload.busquedaEstatus,
                pagina: action.payload.pagina,
                registroPagina: action.payload.registroPagina
            }
        case POST_RESERVAS_EXPIRADAS_EXITO:
            return { ...state, exito: action.payload.exito }
        case PUT_RESERVAS_EXPIRADAS_AUTORIZADO_EXITO:
            return { ...state, exito: action.payload.exito }
        case GET_RESERVAS_EXPIRADAS_ALL:
            return {
                ...state,
                reservas: action.payload.reservas,
                total: action.payload.total
            };
        case CLEAR_RESERVAS_EXPIRADAS_STATE:
            return {
                ...state,
                reservas: action.payload.reservas
            }
        default:
            return state;
    }
}
export const generarReservaAction = ({ idTipoCompra, idPaquete, idCuenta, idMoneda, MontoProveedor, FechaRegreso }) => async (dispatch) => {
    return await newCompraItem({ idTipoCompra, idPaquete, idCuenta, idMoneda, MontoProveedor, FechaRegreso }).then(Response => {
        dispatch({
            type: POST_RESERVAS_EXPIRADAS_EXITO,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const autorizarReservaAction = ({ idCompra }) => async (dispatch) => {
    return await updateAutorizacionCompraItem({ idCompra }).then(Response => {
        dispatch({
            type: PUT_RESERVAS_EXPIRADAS_AUTORIZADO_EXITO,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerReservasExpiradasAction = () => async (dispatch, getSate) => {
    const { busquedaReferencia, busquedaEstatus, pagina, registroPagina } = getSate().reservasExpirdas
    return await getReservasExperidas({ referencia: busquedaReferencia, estusCompra: busquedaEstatus, pagina: pagina + 1, registros: registroPagina }).then(Response => {
        dispatch({
            type: GET_RESERVAS_EXPIRADAS_ALL,
            payload: {
                reservas: Response.listViajeCompra,
                total: Response.tamanio
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerReservasBusquedaAction = ({ Referencia, EstatusCompra }) => async (dispatch, getSate) => {
    return await getReservasExperidas({ referencia: Referencia, estusCompra: EstatusCompra, pagina: dataInicial.pagina + 1, registros: dataInicial.registroPagina }).then(Response => {
        dispatch({
            type: GET_RESERVAS_EXPIRADAS_BUSQUEDA_ALL,
            payload: {
                reservas: Response.listViajeCompra,
                total: Response.tamanio,
                busquedaReferencia: Referencia,
                busquedaEstatus: EstatusCompra,
                pagina: dataInicial.pagina,
                registroPagina: dataInicial.registroPagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerReservasRegistrosAction = ({ Registros }) => async (dispatch, getSate) => {
    const { busquedaReferencia, busquedaEstatus, pagina } = getSate().reservasExpirdas
    return await getReservasExperidas({ referencia: busquedaReferencia, estusCompra: busquedaEstatus, pagina: pagina + 1, registros: Registros }).then(Response => {
        dispatch({
            type: GET_RESERVAS_EXPIRADAS_REGISTROS_PAGINA,
            payload: {
                reservas: Response.listViajeCompra,
                total: Response.tamanio,
                registroPagina: Registros,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerReservasPaginaAction = ({ Pagina }) => async (dispatch, getSate) => {
    const { busquedaReferencia, busquedaEstatus, registroPagina } = getSate().reservasExpirdas
    return await getReservasExperidas({ referencia: busquedaReferencia, estusCompra: busquedaEstatus, pagina: Pagina + 1, registros: registroPagina }).then(Response => {
        dispatch({
            type: GET_RESERVAS_EXPIRADAS_PAGINA,
            payload: {
                reservas: Response.listViajeCompra,
                total: Response.tamanio,
                pagina: Pagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const clearState = () => (dispatch) => {
    dispatch({
        type: CLEAR_RESERVAS_EXPIRADAS_STATE,
        payload: {
            dataInicial,
        },
    });
}